/**
 * Display Rules Tab Component
 * 
 * @package TopBuddy
 */

import UserLoginStatusControl from './display-rules/UserLoginStatusControl';
import UserRolesControl from './display-rules/UserRolesControl';
import DisplayLocationControl from './display-rules/DisplayLocationControl';
import GeneralPagesControl from './display-rules/GeneralPagesControl';
import SpecificPagesControl from './display-rules/SpecificPagesControl';
import ScheduleControl from './display-rules/ScheduleControl';
import ReferrerControl from './display-rules/ReferrerControl';
import QueryParametersControl from './display-rules/QueryParametersControl';
import PageViewsControl from './display-rules/PageViewsControl';
import TimeOnSiteControl from './display-rules/TimeOnSiteControl';
import CookieControl from './display-rules/CookieControl';
import { __experimentalDivider as Divider, __experimentalHeading as Heading } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const DisplayRulesTab = ({ rules, updateRule, displayRulesData }) => {
	const {
		userRoles = {},
		generalPages = {},
		specificPagesLabels = {},
		nonce = '',
		ajaxUrl = '',
	} = displayRulesData;

	return (
		<div className="topbuddy-display-rules">
			<UserLoginStatusControl
				value={rules.user_login_status}
				onChange={(value) => updateRule('user_login_status', value)}
			/>

			{rules.user_login_status === 'logged_in' && (
				<UserRolesControl
					value={rules.user_roles}
					onChange={(value) => updateRule('user_roles', value)}
					availableRoles={userRoles}
					loginStatus={rules.user_login_status}
				/>
			)}

			<DisplayLocationControl
				value={rules.display_location}
				onChange={(value) => updateRule('display_location', value)}
			/>

			{rules.display_location === 'general_pages' && (
				<GeneralPagesControl
					value={rules.general_pages}
					onChange={(value) => updateRule('general_pages', value)}
					availablePages={generalPages}
				/>
			)}

			{rules.display_location === 'specific_pages' && (
				<SpecificPagesControl
					value={rules.specific_pages}
					onChange={(value) => updateRule('specific_pages', value)}
					nonce={nonce}
					ajaxUrl={ajaxUrl}
					initialLabels={specificPagesLabels}
				/>
			)}

			<Divider style={{ marginTop: '5px', marginBottom: '20px' }} />

			<ScheduleControl
				scheduleType={rules.schedule_type}
				onScheduleTypeChange={(value) => updateRule('schedule_type', value)}
				startDate={rules.schedule_start}
				endDate={rules.schedule_end}
				selectedDays={rules.schedule_days}
				onStartDateChange={(value) => updateRule('schedule_start', value)}
				onEndDateChange={(value) => updateRule('schedule_end', value)}
				onSelectedDaysChange={(value) => updateRule('schedule_days', value)}
			/>

			<Divider style={{ marginTop: '20px', marginBottom: '20px' }} />

			<Heading level={4} style={{ marginBottom: '16px' }}>
				{__('Advanced Display Rules', 'topbuddy')}
			</Heading>

			<ReferrerControl
				enabled={rules.referrer_enabled}
				url={rules.referrer_url}
				onEnabledChange={(value) => updateRule('referrer_enabled', value)}
				onUrlChange={(value) => updateRule('referrer_url', value)}
			/>

			<QueryParametersControl
				enabled={rules.query_params_enabled}
				params={rules.query_params}
				onEnabledChange={(value) => updateRule('query_params_enabled', value)}
				onParamsChange={(value) => updateRule('query_params', value)}
			/>

			<PageViewsControl
				enabled={rules.page_views_enabled}
				operator={rules.page_views_operator}
				count={rules.page_views_count}
				onEnabledChange={(value) => updateRule('page_views_enabled', value)}
				onOperatorChange={(value) => updateRule('page_views_operator', value)}
				onCountChange={(value) => updateRule('page_views_count', value)}
			/>

			<TimeOnSiteControl
				enabled={rules.time_on_site_enabled}
				seconds={rules.time_on_site_seconds}
				onEnabledChange={(value) => updateRule('time_on_site_enabled', value)}
				onSecondsChange={(value) => updateRule('time_on_site_seconds', value)}
			/>

			<CookieControl
				enabled={rules.cookie_enabled}
				name={rules.cookie_name}
				value={rules.cookie_value}
				onEnabledChange={(value) => updateRule('cookie_enabled', value)}
				onNameChange={(value) => updateRule('cookie_name', value)}
				onValueChange={(value) => updateRule('cookie_value', value)}
			/>
		</div>
	);
};

export default DisplayRulesTab;
